// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["vendor.min"], () => (__webpack_require__("./node_modules/strophe.js/dist/strophe.umd.js")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendor.min"], () => (__webpack_require__("./node_modules/jquery/dist/jquery.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
